import React from 'react';
import { useHistory } from 'react-router-dom';
import { FaLock, FaArrowLeft, FaEnvelope } from 'react-icons/fa';
import AppLayout from './AppLayout';
import './AccessRestricted.css';

/**
 * AccessRestricted Component
 * Displays a premium access denied page when users don't have access to a feature.
 */
const AccessRestricted = ({ featureName = 'this feature' }) => {
    const history = useHistory();

    return (
        <AppLayout>
            <div className="access-restricted">
                <div className="access-restricted__card">
                    {/* Lock Icon with Animation */}
                    <div className="access-restricted__icon-wrapper">
                        <div className="access-restricted__icon-glow"></div>
                        <div className="access-restricted__icon">
                            <FaLock />
                        </div>
                    </div>

                    {/* Title */}
                    <h1 className="access-restricted__title">Access Restricted</h1>

                    {/* Description */}
                    <p className="access-restricted__description">
                        You don't have permission to access <strong>{featureName}</strong>.
                        This feature is not included in your current subscription plan or has been
                        disabled by your administrator.
                    </p>

                    {/* Info Box */}
                    <div className="access-restricted__info">
                        <div className="access-restricted__info-icon">
                            <FaEnvelope />
                        </div>
                        <div className="access-restricted__info-text">
                            <strong>Need access?</strong>
                            <span>Contact your administrator or upgrade your plan to unlock this feature.</span>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="access-restricted__actions">
                        <button
                            className="access-restricted__btn access-restricted__btn--primary"
                            onClick={() => history.push('/')}
                        >
                            <FaArrowLeft />
                            Go to Dashboard
                        </button>
                        <button
                            className="access-restricted__btn access-restricted__btn--secondary"
                            onClick={() => {
                                const currentPath = history.location.pathname;
                                history.goBack();
                                // Fallback to dashboard if navigation doesn't change route
                                setTimeout(() => {
                                    if (history.location.pathname === currentPath) {
                                        history.push('/');
                                    }
                                }, 100);
                            }}
                        >
                            Go Back
                        </button>
                    </div>
                </div>

                {/* Background Decoration */}
                <div className="access-restricted__bg-pattern"></div>
            </div>
        </AppLayout>
    );
};

export default AccessRestricted;
